import gql from "graphql-tag";
import {client} from "./client";
import {DeleteEntitycontactByObjectid} from "../../schema/DeleteEntitycontactByObjectid";
import {Mutation, FetchResult} from "../../types";

const getMutation = (objectid: number): any => ({
    mutation: gql`${DeleteEntitycontactByObjectid}`,
    variables: {
        objectid,
    }
});

export async function deleteEntitycontactByObjectid (objectid: number) {
    const result: FetchResult<Mutation> = await client.mutate(getMutation(objectid));
    const deleteEntitycontactByObjectid = result?.data?.deleteEntitycontactByObjectid;
    if (!deleteEntitycontactByObjectid) {
        throw new Error('failed to delete entity contact link');
    } else {
        await client.cache.reset();
        return deleteEntitycontactByObjectid.entitycontact;
    }
}
